import { Pencil, Trash2, Save, X } from "lucide-react";

/**
 * The sticky-left row header for a single finish.
 * View mode: name + rename/delete icons.
 * Edit mode: text input + save/cancel icons.
 */
export default function FinishRowHeader({
  finish,
  isEditing,
  nameDraft,
  onDraftChange,
  onStartEdit,
  onSave,
  onCancel,
  onDelete,
}) {
  return (
    <th
      className="sticky left-0 z-10 bg-[#111]/95 backdrop-blur px-3 py-3 text-left align-top border-r border-white/5"
      scope="row"
    >
      {isEditing ? (
        <div className="flex items-center gap-1">
          <input
            className="input-luxe !h-8 !text-sm flex-1 min-w-0"
            value={nameDraft}
            autoFocus
            onChange={(e) => onDraftChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSave();
              if (e.key === "Escape") onCancel();
            }}
            data-testid={`finish-name-input-${finish.id}`}
          />
          <button
            onClick={onSave}
            className="w-7 h-7 rounded-md text-[#C5A880] hover:bg-white/10 shrink-0"
            data-testid={`save-finish-name-${finish.id}`}
            aria-label="Save name"
          >
            <Save size={13} />
          </button>
          <button
            onClick={onCancel}
            className="w-7 h-7 rounded-md text-white/50 hover:bg-white/10 shrink-0"
            aria-label="Cancel"
          >
            <X size={13} />
          </button>
        </div>
      ) : (
        <div className="flex items-start justify-between gap-1">
          <div className="font-medium text-sm text-white leading-tight">
            {finish.name}
          </div>
          <div className="flex items-center gap-0.5 shrink-0">
            <button
              onClick={onStartEdit}
              className="w-6 h-6 rounded text-white/40 hover:text-[#C5A880] hover:bg-white/5"
              data-testid={`edit-finish-name-${finish.id}`}
              aria-label="Rename finish"
              title="Rename"
            >
              <Pencil size={11} />
            </button>
            <button
              onClick={onDelete}
              className="w-6 h-6 rounded text-white/30 hover:text-red-400 hover:bg-white/5"
              data-testid={`delete-finish-${finish.id}`}
              aria-label="Delete finish"
              title="Delete"
            >
              <Trash2 size={11} />
            </button>
          </div>
        </div>
      )}
    </th>
  );
}
